// // import React, { FC, useContext, useEffect, useState } from "react";
// // import { Context, teacherstore } from "../../index";
// // import { useParams } from "react-router-dom";
// // import DrivingNotesComponent from "./DrivingNotesComponent";
// // import TeacherService from "../../services/TeacherService";
// //
// // interface TeacherNotesItemProps {
// //     data: {
// //         studentId: string;
// //         studentName: string;
// //         catA: string;
// //         catB: string;
// //         catC: string;
// //     };
// //     studentId: string;
// // }
// //
// // interface OneCardType {
// //     id: any;
// //     groupId: string;
// //     number: number;
// //     studentName: string;
// //     // Add other properties as needed
// // }
// //
// // const TeacherNotesItem: FC<TeacherNotesItemProps> = ({ data }) => {
// //     const { teacherstore } = useContext(Context);
// //     const [statusValues, setStatusValues] = useState(['🟣Börjat', '🟠Visad kunskap', '🟢Godkänd']); // <-- Removed the space here
// //     const [card, setCard] = useState<any>(null);
// //
// //     const { studentId } = useParams();
// //     const teacherId = teacherstore.teacher.id;
// //
// //     // useEffect(() => {
// //     //     const fetchData = async () => {
// //     //         try {
// //     //             teacherstore.setLoading(true);
// //     //             const response = await teacherstore.gNotesid({ studentId, teacherId });
// //     //             setCard(response);
// //     //         } catch (error) {
// //     //         } finally {
// //     //             teacherstore.setLoading(false);
// //     //         }
// //     //     };
// //     //
// //     //     fetchData();
// //     // }, [studentId]);
// //
// //     useEffect(() => {
// //         const fetchData = async () => {
// //             try {
// //                 teacherstore.setLoading(true);
// //                 const response = await teacherstore.gNotesid({ studentId, teacherId });
// //                 console.log("Data fetched for TeacherNotesItem:", response); // <-- Add this log
// //                 setCard(response);
// //             } catch (error) {
// //                 console.error("Error fetching data for TeacherNotesItem:", error); // Log errors
// //             } finally {
// //                 teacherstore.setLoading(false);
// //             }
// //         };
// //
// //         fetchData();
// //     }, [studentId, teacherId]);
// //
// //     if (!card) {
// //         return null;
// //     }
// //
// //     // Function to update a driving note
// //     const updateDrivingNote = async (card: any, field: any, value: any) => {
// //         const updatedNote = { ...card, [field]: value };
// //         // Send a PUT request to update the note
// //         try {
// //             await TeacherService.updateTeacherNoteByIdT(
// //                 updatedNote.id,
// //                 updatedNote.groupId,
// //                 updatedNote.nytitle,
// //                 updatedNote.statA,
// //                 updatedNote.statB,
// //                 updatedNote.statC,
// //                 updatedNote.statD,
// //                 updatedNote.statE,
// //                 updatedNote.statF,
// //                 updatedNote.statG,
// //                 updatedNote.statH,
// //                 updatedNote.statI,
// //                 updatedNote.isDone
// //             );
// //         } catch (error) {
// //             console.error('Error updating note: ', error);
// //         }
// //     };
// //
// //     const handleStatusChange = (e: any, drivingNoteId: any, fieldName: any) => {
// //         const newStatus = e.target.value;
// //         // Update the local state
// //         setCard((prevCard: any) => {
// //             return {
// //                 ...prevCard,
// //                 drivingNotes: prevCard.drivingNotes.map((note: any) => {
// //                     if (note.id === drivingNoteId) {
// //                         return { ...note, [fieldName]: newStatus };
// //                     }
// //                     return note;
// //                 }),
// //             };
// //         });
// //         // Update the backend data
// //         const cardToUpdate = card.drivingNotes.find((onecard: any) => onecard.id === drivingNoteId);
// //         updateDrivingNote(cardToUpdate, fieldName, newStatus);
// //     };
// //
// //     const handleClick = (drivingNoteId: any) => {
// //         setCard((prevCard: any) => {
// //             return {
// //                 ...prevCard,
// //                 drivingNotes: prevCard.drivingNotes.map((onecard: any) => {
// //                     if (onecard.id === drivingNoteId) {
// //                         return {
// //                             ...onecard,
// //                             isDone: !onecard.isDone,
// //                         };
// //                     }
// //                     return onecard;
// //                 }),
// //             };
// //         });
// //         const cardToUpdate = card.drivingNotes.find((onecard: any) => onecard.id === drivingNoteId);
// //         updateDrivingNote(cardToUpdate, 'isDone', !cardToUpdate.isDone);
// //     };
// //
// //     // Use a counter to assign a number to each unique groupId
// //     let groupIdCounter = 0;
// //     const groupIdNumbers: { [key: string]: number } = {};
// //
// //     return (
// //         <div className="mt-64 jcc center">
// //             {card.drivingNotes
// //                 .slice()
// //                 .sort((a: OneCardType, b: OneCardType) => {
// //                     // First, sort by groupId
// //                     const groupIdComparison = a.groupId.localeCompare(b.groupId);
// //                     if (groupIdComparison !== 0) {
// //                         return groupIdComparison;
// //                     }
// //
// //                     // If groupId is the same, sort by number
// //                     return a.number - b.number;
// //                 })
// //                 .map((onecard: OneCardType) => {
// //                     // Print the group number only once for each groupId
// //                     if (!groupIdNumbers[onecard.groupId]) {
// //                         groupIdCounter += 1;
// //                         groupIdNumbers[onecard.groupId] = groupIdCounter;
// //
// //                         return (
// //                             <React.Fragment key={onecard.groupId} >
// //                                 <section className={'center pt-64'}>
// //                                     <p>{onecard.studentName}s kort</p>
// //                                     <p style={{ fontSize: "1rem", color: "#bebdbd" }}>
// //                                         nummer
// //                                     </p>
// //                                     <p style={{ fontSize: "4rem", color: "#bebdbd" }}>
// //                                         {groupIdNumbers[onecard.groupId]}
// //                                     </p>
// //                                 </section>
// //
// //                                 <div className="ml-8 mr-8">
// //                                         <DrivingNotesComponent
// //                                             key={onecard.id}
// //                                             card={onecard}
// //                                             handleClick={handleClick}
// //                                             handleStatusChange={handleStatusChange}
// //                                             statusValues={statusValues}
// //                                         />
// //                                 </div>
// //                             </React.Fragment>
// //                         );
// //                     }
// //
// //                     return (
// //
// //
// //                         <div key={onecard.id} className={'ml-8 mr-8 '}>
// //                             <DrivingNotesComponent
// //                                 card={onecard}
// //                                 handleClick={handleClick}
// //                                 handleStatusChange={handleStatusChange}
// //                                 statusValues={statusValues}
// //                             />
// //                         </div>
// //                     );
// //                 })}
// //         </div>
// //     );
// // };
// //
// // export default TeacherNotesItem;
// //
//
//
// import React, { FC, useContext, useEffect, useState } from "react";
// import { Context } from "../../index";
// import { useParams } from "react-router-dom";
// import DrivingNotesComponent from "./DrivingNotesComponent";
// import TeacherService from "../../services/TeacherService";
// import noteItem from "../MyDrivingNotesPage/NoteItem";
//
// interface TeacherNotesItemProps {
//     data: {
//         studentId: string;
//         studentName: string;
//         catA: string;
//         catB: string;
//         catC: string;
//     };
//     studentId: string;
// }
//
// interface OneCardType {
//     id: any;
//     groupId: string;
//     number: number;
//     studentName: string;
//     // Add other properties as needed
// }
//
// const TeacherNotesItem: FC<TeacherNotesItemProps> = ({ data }) => {
//     const { teacherstore } = useContext(Context);
//     const [statusValues] = useState(['🟣Börjat', '🟠Visad kunskap', '🟢Godkänd']);
//     const [card, setCard] = useState<any>(null);
//     const [currentIndex, setCurrentIndex] = useState(0);
//
//     const { studentId } = useParams();
//     const teacherId = teacherstore.teacher.id;
//
//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 teacherstore.setLoading(true);
//                 const response = await teacherstore.gNotesid({ studentId, teacherId });
//                 setCard(response);
//                 setCurrentIndex(0); // Reset index on new load
//             } catch (error) {
//                 console.error("Error fetching data for TeacherNotesItem:", error);
//             } finally {
//                 teacherstore.setLoading(false);
//             }
//         };
//
//         fetchData();
//     }, [studentId, teacherId]);
//
//     if (!card) {
//         return null;
//     }
//
//     const updateDrivingNote = async (card: any, field: any, value: any) => {
//         const updatedNote = { ...card, [field]: value };
//         try {
//             await TeacherService.updateTeacherNoteByIdT(
//                 updatedNote.id,
//                 updatedNote.groupId,
//                 updatedNote.nytitle,
//                 updatedNote.statA,
//                 updatedNote.statB,
//                 updatedNote.statC,
//                 updatedNote.statD,
//                 updatedNote.statE,
//                 updatedNote.statF,
//                 updatedNote.statG,
//                 updatedNote.statH,
//                 updatedNote.statI,
//                 updatedNote.isDone
//             );
//         } catch (error) {
//             console.error('Error updating note: ', error);
//         }
//     };
//
//     const handleStatusChange = (e: any, drivingNoteId: any, fieldName: any) => {
//         const newStatus = e.target.value;
//         setCard((prevCard: any) => {
//             return {
//                 ...prevCard,
//                 drivingNotes: prevCard.drivingNotes.map((note: any) => {
//                     if (note.id === drivingNoteId) {
//                         return { ...note, [fieldName]: newStatus };
//                     }
//                     return note;
//                 }),
//             };
//         });
//         const cardToUpdate = card.drivingNotes.find((onecard: any) => onecard.id === drivingNoteId);
//         updateDrivingNote(cardToUpdate, fieldName, newStatus);
//     };
//
//     const handleClick = (drivingNoteId: any) => {
//         setCard((prevCard: any) => {
//             return {
//                 ...prevCard,
//                 drivingNotes: prevCard.drivingNotes.map((onecard: any) => {
//                     if (onecard.id === drivingNoteId) {
//                         return {
//                             ...onecard,
//                             isDone: !onecard.isDone,
//                         };
//                     }
//                     return onecard;
//                 }),
//             };
//         });
//         const cardToUpdate = card.drivingNotes.find((onecard: any) => onecard.id === drivingNoteId);
//         updateDrivingNote(cardToUpdate, 'isDone', !cardToUpdate.isDone);
//     };
//
//     // Sort drivingNotes
//     const sortedNotes = card.drivingNotes
//         .slice()
//         .sort((a: OneCardType, b: OneCardType) => {
//             const groupIdComparison = a.groupId.localeCompare(b.groupId);
//             return groupIdComparison !== 0 ? groupIdComparison : a.number - b.number;
//         });
//
//     const currentCard = sortedNotes[currentIndex];
//
//     const goToPrevious = () => {
//         setCurrentIndex((prev) => (prev > 0 ? prev - 1 : prev));
//     };
//
//     const goToNext = () => {
//         setCurrentIndex((prev) => (prev < sortedNotes.length - 1 ? prev + 1 : prev));
//     };
//
//
//     console.log(card)
//     return (
//         <div className="mt-64 jcc center">
//             {currentCard && (
//                 <>
//                     <section className={'center pt-64'}>
//                         <p>{currentCard.studentName}s kort</p>
//                         <p style={{ fontSize: "1rem", color: "#bebdbd" }}>nummer</p>
//                         <p style={{ fontSize: "4rem", color: "#bebdbd" }}>{ card.groupId}</p>
//                     </section>
//
//
//                     <div className="card p-32 center">
//                         <button
//                             onClick={goToPrevious}
//                             disabled={currentIndex === 0}
//                             className="buttonM"
//                         >
//                             ◀ Föregående
//                         </button>
//
//                         <button
//                             onClick={goToNext}
//                             disabled={currentIndex === sortedNotes.length - 1}
//                             className="buttonM"
//                         >
//                             Nästa ▶
//                         </button>
//
//                         <p className="text-center mt-4 text-sm text-gray-500">
//                             Kort {currentIndex + 1} av {sortedNotes.length}
//                         </p>
//
//                     </div>
//
//
//
//                     <div className="ml-8 mr-8">
//                         <DrivingNotesComponent
//                             card={currentCard}
//                             handleClick={handleClick}
//                             handleStatusChange={handleStatusChange}
//                             statusValues={statusValues}
//                         />
//                     </div>
//
//                 </>
//             )}
//         </div>
//     );
// };
//
// export default TeacherNotesItem;



import React, { FC, useContext, useEffect, useState } from "react";
import { Context } from "../../index";
import { useParams } from "react-router-dom";
import DrivingNotesComponent from "./DrivingNotesComponent";
import TeacherService from "../../services/TeacherService";

interface TeacherNotesItemProps {
    data: {
        studentId: string;
        studentName: string;
        catA: string;
        catB: string;
        catC: string;
    };
    studentId: string;
}

interface OneCardType {
    id: string;
    groupId: string;
    number: number;
    studentName: string;
    isDone: boolean;
    nytitle: string;
    catA: string;
    catB: string;
    catC: string;
    [key: string]: any;
}
const TeacherNotesItem: FC<TeacherNotesItemProps> = ({ data }) => {
    const { teacherstore } = useContext(Context);
    const [statusValues] = useState(['🟣Börjat', '🟠Visad kunskap', '🟢Godkänd']);
    const [card, setCard] = useState<any>(null);
    const [currentGroupId, setCurrentGroupId] = useState<string | null>(null);
    const [currentIndex, setCurrentIndex] = useState(0);

    const { studentId } = useParams();
    const teacherId = teacherstore.teacher.id;

    useEffect(() => {
        const fetchData = async () => {
            try {
                teacherstore.setLoading(true);
                const response = await teacherstore.gNotesid({ studentId, teacherId });
                setCard(response);
                // @ts-ignore
                const sorted = [...response.drivingNotes].sort((a, b) => a.groupId.localeCompare(b.groupId));
                const firstGroup = sorted[0]?.groupId || null;
                setCurrentGroupId(firstGroup);
                setCurrentIndex(0);
            } catch (error) {
                console.error("Error fetching data for TeacherNotesItem:", error);
            } finally {
                teacherstore.setLoading(false);
            }
        };

        fetchData();
    }, [studentId, teacherId]);

    if (!card) return null;

    const sortedNotes = [...card.drivingNotes].sort((a, b) => {
        const groupCompare = a.groupId.localeCompare(b.groupId);
        return groupCompare !== 0 ? groupCompare : a.number - b.number;
    });

    // @ts-ignore
    const uniqueGroupIds = [...new Set(sortedNotes.map((note) => note.groupId))];

    // Filter cards by currently selected group
    const groupNotes = currentGroupId
        ? sortedNotes.filter((note) => note.groupId === currentGroupId)
        : [];

    const currentCard = groupNotes[currentIndex] || null;

    const updateDrivingNote = async (note: any, field: any, value: any) => {
        const updatedNote = { ...note, [field]: value };
        try {
            await TeacherService.updateTeacherNoteByIdT(
                updatedNote.id,
                updatedNote.groupId,
                updatedNote.nytitle,
                updatedNote.statA,
                updatedNote.statB,
                updatedNote.statC,
                updatedNote.statD,
                updatedNote.statE,
                updatedNote.statF,
                updatedNote.statG,
                updatedNote.statH,
                updatedNote.statI,
                updatedNote.isDone
            );
        } catch (error) {
            console.error('Error updating note: ', error);
        }
    };

    const handleStatusChange = (e: any, id: string, field: string) => {
        const newStatus = e.target.value;
        setCard((prevCard: any) => ({
            ...prevCard,
            drivingNotes: prevCard.drivingNotes.map((note: OneCardType) =>
                note.id === id ? { ...note, [field]: newStatus } : note
            ),
        }));

        const updatedNote = card.drivingNotes.find((note: OneCardType) => note.id === id);
        updateDrivingNote(updatedNote, field, newStatus);
    };

    const handleClick = (id: string) => {
        setCard((prevCard: any) => ({
            ...prevCard,
            drivingNotes: prevCard.drivingNotes.map((note: OneCardType) =>
                note.id === id ? { ...note, isDone: !note.isDone } : note
            ),
        }));

        const updatedNote = card.drivingNotes.find((note: OneCardType) => note.id === id);
        updateDrivingNote(updatedNote, 'isDone', !updatedNote.isDone);
    };

    const goToPrevious = () => {
        setCurrentIndex((prev) => (prev > 0 ? prev - 1 : prev));
    };

    const goToNext = () => {
        setCurrentIndex((prev) => (prev < groupNotes.length - 1 ? prev + 1 : prev));
    };

    const handleGroupChange = (groupId: string) => {
        setCurrentGroupId(groupId);
        setCurrentIndex(0);
    };

    const currentGroupNumber = currentGroupId
        ? uniqueGroupIds.findIndex(id => id === currentGroupId) + 1
        : 0;

    return (
        <div className="card3 ml-8 mr-8" style={{margin: "0 auto", marginTop: "100px"}}>
            {currentCard && (
                <>
                        <p className="mb-4 text-sm text-gray-600">Övningskort nummer:</p>
                        <div className="center mt-4">
                            {uniqueGroupIds.map((id, index) => (
                                <button
                                    key={id}
                                    className={`ghostbutton mr-2 ${id === currentGroupId ? 'bg-purple-400' : ''}`}
                                    onClick={() => handleGroupChange(id)}
                                >
                                    <p>Kortet</p>
                                    <p style={{ fontSize: "3rem", color: "#bebdbd" }}> {index + 1}</p>
                                </button>
                            ))}
                        </div>



                    <div className="center ml-8 mr-8">
                        <DrivingNotesComponent
                            card={currentCard}
                            handleClick={handleClick}
                            handleStatusChange={handleStatusChange}
                            statusValues={statusValues}
                            currentIndex={currentIndex}
                            groupLength={groupNotes.length}
                            goToPrevious={goToPrevious}
                            goToNext={goToNext}
                        />

                    </div>
                </>
            )}
        </div>
    );
};

export default TeacherNotesItem;
